import { workerstationService } from "@workerstation/shared/effect/service";
import { Context, Effect, Schema } from "effect";
import type { RuntimeDependencyError } from "../errors/dependency.ts";

export const UnitInterval = /* @__PURE__ */ (() => Schema.Number.check(
  Schema.isGreaterThanOrEqualTo(0), Schema.isLessThan(1)
))();
export const EntropyByteCount = /* @__PURE__ */ (() => Schema.Int.check(
  Schema.isBetween({ minimum: 0, maximum: 65_536 })
))();

export class IdEntropy extends workerstationService<IdEntropy, {
  /** Non-secret sampling, used only for human-readable names. */
  readonly unit: Effect.Effect<number, RuntimeDependencyError>;
  /** Cryptographic entropy for recording identities and session credentials. */
  readonly bytes: (length: number) => Effect.Effect<Uint8Array, RuntimeDependencyError>;
  /** Native UUID generation retains the platform's receiver and call boundary. */
  readonly uuid: Effect.Effect<string, RuntimeDependencyError>;
}>()("IdEntropy") {}
